export enum ErrorEnum {
    INVALID_FORM_INPUT = 'INVALID_FORM_INPUT',
    GENERIC_ERROR = 'GENERIC_ERROR',
    USER_ALREADY_ACTIVATED = 'USER_ALREADY_ACTIVATED'
}
